import React from "react";
import PropTypes from "prop-types";
import { Accordion, Card, Button, ListGroup } from "react-bootstrap";
import NavbarLink from "../NavbarLink";
const Roles = ({ roles_add }) => {
    return (
        <Card id="roles-toggle-list">
            <Card.Header>
                <Accordion.Toggle
                    as={Button}
                    variant="light"
                    eventKey="roles-toggle-list"
                >
                    <span className="text-dark">
                        <i className="fa fa-user-tag" /> Roles
                    </span>
                </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="roles-toggle-list">
                <Card.Body className="p-0">
                    <ListGroup>
                        <ListGroup.Item>
                            <NavbarLink
                                to="/app/roles"
                                className="dropdown-item"
                                label={`View Roles`}
                            />
                        </ListGroup.Item>

                        {roles_add && (
                            <ListGroup.Item>
                                <a
                                    href="/app/roles/add"
                                    className="dropdown-item"
                                >
                                    Add Role
                                </a>
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
};

Roles.propTypes = { roles_add: PropTypes.bool };

export default Roles;